var _defs, _g, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanglyai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 120,
    viewBox: "0 0 420 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "langlyGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2563EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06B6D4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 20,
    ry: 20,
    width: 80,
    height: 80,
    fill: "url(#langlyGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 26h36c4 0 7 3 7 7v14c0 4-3 7-7 7H40l-8 8v-8h-10c-4 0-7-3-7-7V33c0-4 3-7 7-7z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 30,
    r: 3,
    fill: "#2563EB"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 65,
    fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 700,
    fill: "#0F172A"
  }, "\n    Langly\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 65,
    fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    fontSize: 42,
    fontWeight: 700,
    fill: "url(#langlyGradient)"
  }, "\n    AI\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 122,
    y: 90,
    fontFamily: "Inter, Segoe UI, Arial, sans-serif",
    fontSize: 14,
    fill: "#475569"
  }, "\n    Learn French, the Smart Way\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanglyai);
export default __webpack_public_path__ + "static/media/langlyai.401faa41fcac0dd4a05620acdfad8e83.svg";
export { ForwardRef as ReactComponent };